import Component from '@glimmer/component';

// StudentReportCard is one report row on a student's reporting page, in the
// Active or the Historic section.
//
// Args:
//  - entry: a row from the student controller's _reportItem.
//  - person: the student.
//  - isiOS, isTenantAdmin: display flags.
//  - isLast: the final card in its timeline run; hides the trailing connector.
//  - showTimeline: draws the timeline gutter (dot + connector). Defaults to
//    true. Callers pass false when there is no run to draw — a lone card in the
//    Active section would show a single dot connected to nothing. The Historic
//    section always keeps it, since the dots connect up to the year node.
//  - onView, onReopen, onVoid, onVoidRecreate: each is called with the entry.
export default class StudentReportCard extends Component {
  get showTimeline() {
    return this.args.showTimeline ?? true;
  }
}
